module.exports = __webpack_public_path__ + "img/des_jita_02.e0d9d94f.jpg";